<template>
  <footer class="footer">
    <div class="container">
      <p>&copy; 2024 Ammara Hoosen. UI/UX Designer & Web Developer</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped>
.footer {
  background-color: #333;
  color: #fff;
  text-align: center;
  padding: 10px;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
}
</style>
